import React from 'react';
import { css, cx } from 'emotion';

import HubbleLogo from 'site-react/core/HubbleLogo';
import JsonLD from 'site-react/core/helpers/jsonLD';
import TrustPilot from 'site-react/shared/TrustPilot';
import VerticalSpacing from 'site-react/core/VerticalSpacing';
import theme from 'site-react/theme';

import { footerContentPadding, footerLineBreakBottom } from './Footer.styles';

import { ratingData } from './FooterSchemaData';
import { footerSmallTextStyle, footerLinkStyle } from './Footer.styles';

const logoStyle = css`
  color: ${theme.colors.brandPrimary};
  text-align: center;
`;

const FooterRatingBlock = () => (
  <div className={cx(footerLineBreakBottom, footerContentPadding)}>
    <JsonLD data={ratingData} />
    <div className={logoStyle}>
      <HubbleLogo color="currentColor" size={48} />
    </div>
    <span className={footerSmallTextStyle}>
      <img
        alt=""
        src="https://hubble.imgix.net/images/site/footer/google-stars.png"
      />
    </span>
    <span className={footerSmallTextStyle}>
      <a
        href="http://bit.ly/2xPqCsV"
        target="_blank"
        rel="noreferrer noopener"
        className={footerLinkStyle}
      >
        4.9 / 5 Google Reviews
      </a>
    </span>
    <VerticalSpacing size="md" />
    <TrustPilot isInverted location="footer" />
  </div>
);

export default FooterRatingBlock;
